import { selectSerializer } from 'libs/serializers';
import useFetchResource from '../useFetchResource';
import api from 'libs/api';
import { IOption } from 'components/Form/Select/SingleSelect';

interface ICountry extends IOption {
  id: number;
  title: string;
  short_code: string;
}

export function useCountries(initialLoad = true) {
  const { resource: countries, fetchResource: fetchCountries } = useFetchResource<ICountry[]>({
    api: api.location.getCountries,
    initialValues: [],
    initialLoad,
    serializer: (data) =>
      selectSerializer(data.resources, { labelKey: 'title', valueKey: 'short_code' }),
  });

  return { countries, fetchCountries };
}
